// extracted by mini-css-extract-plugin
module.exports = {"Balloon":"balloon_Balloon__R5iTv","Datetime":"balloon_Datetime__n22AW","MessageWrapper":"balloon_MessageWrapper__NUuBm","TableWrapper":"balloon_TableWrapper__1m6YQ"};